module.exports = __webpack_public_path__ + "static/media/success-symbol.8e0db5bd.svg";